import * as style from './style.module.css';

const ScrollIndicator = ({ className = '' }) => {
  return (
    <div className={`${style.root} ${className}`}>
      <div className={style.circle}/>
    </div>
  )
}

export default ScrollIndicator
